import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { industrialMinerals } from "../Data";
import BreadCrumb from "../Components/BreadCrumb";
import MineralIntro from "../Components/MineralIntro";
import MineralTabs from "../Components/MineralTabs";
import MineralSpecifications from "../Components/MineralSpecifications";
import MineralStats from "../Components/MineralStats";
import MineralFaqs from "../Components/MineralFaqs";
import MineralCta from "../Components/MineralCta";
import OtherMinerals from "../Components/OtherMinerals";
import ContactSection from "../Components/ContactSection";
import NotFound from "./NotFound";
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import webPageSchema from "../Schema/WebPageSchema";
import productSchema from "../Schema/ProductSchema";

const IndustrialDetail=()=>{
    const { slug } = useParams();
  const industrialMineral = industrialMinerals.find(item => item.url === slug);

  useEffect(() => {
    if (!industrialMineral) return;
    document.title = industrialMineral.metaTitle;

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) metaDesc.setAttribute("content", industrialMineral.metaDescription);

      let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://irisimpulse.com/industrial-minerals/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
    industrialMineral.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
     industrialMineral.metaDescription
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://irisimpulse.com/industrial-minerals/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      `https://irisimpulse.com${industrialMineral.ogImage}`
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
    industrialMineral.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
    industrialMineral.metaDescription
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      `https://irisimpulse.com${industrialMineral.ogImage}`
    );
  }

}, [industrialMineral, slug]);

  if (!industrialMineral) return <NotFound />;

  const organizationData = organizationSchema();
  const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "Industrial Minerals",
      url: "https://irisimpulse.com/industrial-minerals",
    },
    {
      name: industrialMineral.emailTitle,
    },
  ],
});
const webPageData = webPageSchema({
  url: `https://irisimpulse.com/industrial-minerals/${industrialMineral.url}`,
  title: industrialMineral.emailTitle,
  description:industrialMineral.metaDescription,
  image: `https://irisimpulse.com${industrialMineral.ogImage}`,
});
const productData = productSchema({
  name: industrialMineral.emailTitle,
  description: industrialMineral.metaDescription,
  image: `https://irisimpulse.com${industrialMineral.ogImage}`,
  url: `https://irisimpulse.com/industrial-minerals/${industrialMineral.url}`,
});

    return(
        <>

        <SchemaMarkup data={organizationData} />
        <SchemaMarkup data={breadcrumbData} />
        <SchemaMarkup data={webPageData} />
        <SchemaMarkup data={productData} />
        <React.Fragment key={slug}>

               <BreadCrumb
  title={`${industrialMineral.title}`}
  bgImage={industrialMineral.bgImg} 
/>

       {/**INTRODUCTION SECTION */}
        <MineralIntro
        heading={industrialMineral.introHeading}
        desc={industrialMineral.introPara}
        img={industrialMineral.introImg}
        mineral={industrialMineral}
        />

        {/**TABS SECTION */}
        <MineralTabs
  data={industrialMineral.tabsData}
/>

        <MineralSpecifications
        heading={industrialMineral.specHeading}
        desc={industrialMineral.specDesc}
        />

        {/**PACKING & SUPPLY OPTION SECTION */}
        <MineralStats
        images={industrialMineral.packingImages}
          heading1={industrialMineral.packingHeading}
          desc1={industrialMineral.packingDesc}
          heading2={industrialMineral.statsHeading}
          desc2={industrialMineral.statsDesc}
          stats={industrialMineral.stats}
        />

        {/**FAQS SECTION */}
        <MineralFaqs
          heading={industrialMineral.faqsHeading}
          description={industrialMineral.faqsDesc}
          faqs={industrialMineral.faqs}
        />

        {/**CTA SECTION */}
        <MineralCta
        heading={industrialMineral.ctaHeading}
        desc={industrialMineral.ctaDesc}
        />

        {/**OTHER MINERALS SECTION */}
        <OtherMinerals
  heading="Explore Other Industrial Minerals from Iris Impulse"
  minerals={industrialMinerals}
  currentMineralId={industrialMineral.id}
  basePath="/industrial-minerals"
/>

 {/**CONTACT FORM SECTION */}
    <ContactSection />

        </React.Fragment>
        </>
    )
}
export default IndustrialDetail;